export default "/images/vendor/flag-icons/flags/1x1/rw.svg?2dbaa32bbc3d280477a01fcb91313d3f";